import type SessionService from '@efdigital/ll-addon-auth/services/session';
import type { Apis } from '@efdigital/ll-addon-auth/types/apis';
import type {
  Coaching,
  CoachingConfig,
  CoachingPlan,
  Cohort,
} from '@efdigital/ll-addon-data';
import config from '@efdigital/ll-xceed-v2/config/environment';
import { findCohortById } from '@efdigital/ll-xceed-v2/data/builders/xceed/cohorts';
import type CoacheeService from '@efdigital/ll-xceed-v2/services/coachee';
import { CoachingPlanner } from '@efdigital/ll-xceed-v2/utils/coaching/coachee/coaching-plan-manager';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

const apis: Apis = config['ll-addon-auth-apis'];

export type CoachingCoacheeCohortPathParams = {
  program_id: string;
  cohort_id: string;
};

export type CoachingCoacheeCohortModel = CoachingCoacheeCohortPathParams & {
  isCoachee: boolean;
  cohort: Cohort;
  coaching: Coaching;
  coachingConfig: CoachingConfig;
  coachingPlan: CoachingPlan | null;
  planner: CoachingPlanner;
  cohortsWithCoaching: Cohort[];
};

export default class CoachingCoacheeCohortRoute extends Route<CoachingCoacheeCohortModel> {
  @service declare coachee: CoacheeService;
  @service declare store: Store;
  @service declare session: SessionService;

  async model(
    params: CoachingCoacheeCohortPathParams
  ): Promise<CoachingCoacheeCohortModel> {
    const cohortsWithCoaching = await this.coachee.cohortsWithCoaching();

    const getCohort = await this.store.request(
      findCohortById(params.cohort_id)
    );
    if (!getCohort.content.data) {
      throw new Error('Cohort not found');
    }

    console.log(
      'cohort route getting cohort from store',
      getCohort.content.data
    );
    const cohort = getCohort.content.data;
    const coaching = await cohort.coaching;
    if (!coaching) {
      throw new Error('Coaching not configured for cohort');
    }

    const coachingConfig = await coaching.coachingConfig;
    if (!coachingConfig) {
      throw new Error('Coaching config not found');
    }

    const isCoachee = await this.coachee.isCoachee();
    if (!isCoachee) {
      throw new Error('User is not a coachee');
    }
    const coachingPlan = await this.coachee.ensureCoachingPlan(coaching);
    if (!coachingPlan) {
      throw new Error('Coaching plan not found');
    }

    return {
      ...params,
      cohort,
      coaching,
      isCoachee,
      coachingPlan,
      coachingConfig,
      cohortsWithCoaching,
      planner: await CoachingPlanner.load(coachingPlan, {
        store: this.store,
        coachee: this.coachee,
        session: this.session,
        apis,
      }),
    };
  }
}
